import React, { FC, useContext } from 'react';
import { ContextApi } from 'react-uforms';
import { Box } from '@ch/common/components/box';
import { Button } from '@ch/common/components/button';
import { Question } from '@ch/common/types/data';
import { IconDelete } from '@ch/common/components/icon';
import QuizField from './quiz-field';
import { QuizComplexFieldBlockStyled, QuizComplexFieldDelete } from './quiz.styled';
import { boxProps } from './const';

const QuizFieldComplex: FC<Question> = ({ identifier: name, children }) => {
  const { getValue, setValue } = useContext(ContextApi);
  const value = getValue(name);
  return (
    <>
      {[...(!value ? Array(1) : value)].map((item, index) => (
        <Box key={index} $p={index > 0 ? [15, 0, 0] : [0]} $m={[0, 0, 10]}>
          {children?.length > 0 && (
            <QuizComplexFieldBlockStyled {...boxProps}>
              {index > 0 && (
                <QuizComplexFieldDelete
                  $variant="link"
                  $size="sm"
                  $color="grayDarker"
                  onClick={() => {
                    setValue(
                      name,
                      getValue(name).filter((item, itemIndex) => index !== itemIndex),
                    );
                  }}
                >
                  <IconDelete $size={14} />
                </QuizComplexFieldDelete>
              )}
              {children.map(({ identifier: childName, ...rest }) => (
                <Box $m={[-10, 0, 0]} key={`${name}_${index}_${childName}`}>
                  <QuizField {...{ identifier: `${name}[${index}][${childName}]`, ...rest }} />
                </Box>
              ))}
            </QuizComplexFieldBlockStyled>
          )}
        </Box>
      ))}

      <Button
        $variant="link"
        $size="sm"
        onClick={() => {
          setValue(name, Array.isArray(value) ? [...value, {}] : [value, {}]);
        }}
      >
        + Add more
      </Button>
    </>
  );
};

export default QuizFieldComplex;
